import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FlyoutTodayComponent } from './flyout-today.component';

@NgModule({ declarations: [FlyoutTodayComponent],
    exports: [FlyoutTodayComponent], imports: [CommonModule, ModalModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class FlyoutTodayModule {}
